// =====================================
//
//   Point 相關功能 Service
//   Author: Wayne
//   createtime: 2016 / 08 / 26
//
// =====================================
window.InifECShared.factory("PointService", ['$q', '$http', 'Upload', function($q, $http, Upload) {

    var factory = {};

    // 最新點數資訊
    var lastPoint = {
        loanbalance: 0,  // 放款餘額
        pointsbalance: 0,  // 點數餘額
        updatetime: undefined, // 更新時間
        remainder: 0,  // 銷貨收入餘額
        userpointtype: 0,  // 用戶型態 0: 預儲 1: 月結
        monthlylimit: 0,  // 月結額度上限
        enableflag: true,  // 點數是否被凍結
        isLoaded: false,
    }

    // --------------------------------
    // 重置點數資訊
    // --------------------------------
    var resetLastPoint = function() {

        factory.lastPoint.loanbalance = 0;
        factory.lastPoint.pointsbalance = 0;
        factory.lastPoint.updatetime = undefined;
        factory.lastPoint.remainder = 0;
        factory.lastPoint.userpointtype = 0;
        factory.lastPoint.monthlylimit = 0;
        factory.lastPoint.enableflag = true;
        factory.lastPoint.isLoaded = false;
    }

    // --------------------------------
    // 取得儲值紀錄列表
    // --------------------------------
    var getPurchaseLogList = function(start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsAction.do",
            method: "GET",
            params: {
                op: "getPurchaseLogList",
                start: start,
                len: len,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointService.getPurchaseLogList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }
  
    // --------------------------------
    // 取得消費紀錄列表
    // --------------------------------
    var getConsumeLogList = function(start, len, starttime ,endtime) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsAction.do",
            method: "GET",
            params: {
                op: "getConsumeLogList",
                start: start,
                len: len,
                starttime: starttime,
                endtime: endtime,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointService.getConsumeLogList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得會員點數餘額
    // --------------------------------
    var getMemberPointsBalance = function() {

    	var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsAction.do",
            method: "GET",
            params: {
                op: "getMemberPointsBalance"
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {

                if(data && data.logid) {
                    factory.lastPoint.loanbalance = data.loanbalance;
                    factory.lastPoint.pointsbalance = data.pointsbalance;
                    factory.lastPoint.updatetime = data.updatetime;
                    factory.lastPoint.remainder = data.remainder;
                    factory.lastPoint.userpointtype = data.userpointtype;
                    factory.lastPoint.monthlylimit = data.monthlylimit;
                    factory.lastPoint.enableflag = data.enableflag;
                }

                factory.lastPoint.isLoaded = true;

                defer.resolve(factory.lastPoint);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointService.getMemberPointsBalance request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得最後一比入帳記錄
    // --------------------------------
    var getLastPurchaseLog = function() {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsAction.do",
            method: "GET",
            params: {
                op: "getLastPurchaseLog",
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointService.getLastPurchaseLog request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    factory.lastPoint = lastPoint;
	/*==========================
        Methods
    ==========================*/
    // 重置點數資訊
    factory.resetLastPoint = resetLastPoint;
    // 取得儲值紀錄列表
    factory.getPurchaseLogList = getPurchaseLogList;
    // 取得消費紀錄列表
    factory.getConsumeLogList = getConsumeLogList;
    // 取得會員點數餘額
    factory.getMemberPointsBalance = getMemberPointsBalance;
    // 取得最後一比入帳記錄
    factory.getLastPurchaseLog = getLastPurchaseLog;

    return factory;
}]);